// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"6547b2eb","502":"dec4c112","641":"55e76e1a","5780":"55e76e1a","5811":"668baa57","5977":"55e76e1a","9265":"1ca560f8","9268":"0cfd31d9"}[chunkId] + ".chunk.css";
};